export const MINIMAL_YEAR = 2020;
export const MAXIMAL_YEAR = 2025;
export const SpeState = { Default: 0, Like: 1, Could: 2, Never: 3 };
export const SpeStateName = {0: "Default", 1: "Like", 2: "Could", 3: "Never" };